module.exports = "<canvas id=\"model\"></canvas>\n\n"